<template>
  <div>
    <b-card no-body>
      <b-card-body>
        <b-row class="align-items-center">
          <b-col md="8">
            <b-button variant="success" @click="openUploader" class="mr-1">
              <feather-icon icon="UploadCloudIcon" class="mr-50" />
              Importar Excel
            </b-button>

            <b-button
              variant="outline-info"
              :disabled="loading"
              @click="exportImportacion"
              class="mr-1"
            >
              <feather-icon icon="DownloadIcon" class="mr-50" />
              Exportar Importación
            </b-button>

            <b-input-group size="sm" class="d-inline-flex w-auto mr-1">
              <b-input-group-prepend is-text>
                <small>Excel:</small>
              </b-input-group-prepend>
              <b-form-select
                v-model="selectedBatchId"
                :options="batchOptions"
                :disabled="loading || batches.length === 0"
                class="mr-1"
              />
            </b-input-group>

            <b-button
              variant="danger"
              @click="onSoftDelete"
              :disabled="loading || !selectedBatchId"
            >
              <feather-icon icon="TrashIcon" class="mr-50" />
              Eliminar
            </b-button>
          </b-col>

          <b-col md="4" class="text-right">
            <b-input-group size="sm" class="d-inline-flex w-auto mr-1">
              <b-input-group-prepend is-text>
                <feather-icon icon="SearchIcon" />
              </b-input-group-prepend>
              <b-form-input
                v-model="q"
                placeholder="Buscar modelo o DUA…"
                @input="applyFilter"
              />
            </b-input-group>
            <b-badge variant="light-primary"
              >Registros: {{ totalElements }}</b-badge
            >
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <b-card no-body>
      <b-table
        :items="pagedRecords"
        :fields="fields"
        :busy="loading"
        responsive
        small
        show-empty
        empty-text="Sin registros"
        class="position-relative"
      >
        <template #cell(cantidad_dua)="ctx">
          <div class="text-right">
            {{ ctx.item.cantidad_dua.toLocaleString() }}
          </div>
        </template>

        <template #cell(total_importado)="ctx">
          <div class="text-right">
            {{ ctx.item.total_importado.toLocaleString() }}
          </div>
        </template>

        <template #cell(peso_dua)="ctx">
          <div class="text-right">{{ fmtPct(ctx.item.peso_dua) }}</div>
        </template>

        <template #table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner class="align-middle mr-1" />
            <strong>Cargando…</strong>
          </div>
        </template>
      </b-table>

      <b-row class="mx-2 mb-2">
        <b-col sm="3" class="d-flex align-items-center">
          <span class="text-muted">Mostrar</span>
          <b-form-group class="mb-0 ml-50">
            <b-form-select
              v-model="perPage"
              :options="perPageOptions"
              @change="rebuildPagination"
            />
          </b-form-group>
          <span class="text-muted ml-50">entradas</span>
        </b-col>

        <b-col sm="3" class="mt-75" style="font-size: 12px">
          <span>{{ totalElements }} registros en total</span>
        </b-col>

        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-sm-end"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalElements"
            :per-page="perPage"
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text
              ><feather-icon icon="ChevronLeftIcon" size="18"
            /></template>
            <template #next-text
              ><feather-icon icon="ChevronRightIcon" size="18"
            /></template>
          </b-pagination>
        </b-col>
      </b-row>
    </b-card>

    <b-modal id="upload-modal" title="Importar Excel (importación)" hide-footer>
      <b-form-file
        v-model="file"
        accept=".xlsx"
        @input="validateFile"
        browse-text="Elegir archivo"
      />
      <small class="text-muted d-block mt-1">
        Columnas esperadas: <b>cantidad</b>, <b>modelo</b>, <b>dua</b>,
        <b>importador</b>
      </small>
      <div class="text-right mt-2">
        <b-button
          variant="outline-secondary"
          class="mr-50"
          @click="$bvModal.hide('upload-modal')"
          >Cancelar</b-button
        >
        <b-button
          :disabled="!validFile || uploading"
          variant="primary"
          @click="submitUpload"
        >
          <b-spinner small v-if="uploading" class="mr-50" /> Subir
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from "vue";
import ImportExcelService from "@/services/ImportExcelService";
import Ripple from "vue-ripple-directive";
import { BootstrapVue, BootstrapVueIcons, VBTooltip } from "bootstrap-vue";
import * as XLSX from "xlsx";

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
export default {
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  data() {
    return {
      fields: [
        { key: "modelo", label: "Modelo", sortable: true },
        { key: "dua", label: "DUA", sortable: true },
        { key: "importador", label: "Importador" },
        {
          key: "cantidad_dua",
          label: "Cantidad (DUA)",
          thClass: "text-right",
          tdClass: "text-right",
        },
        {
          key: "total_importado",
          label: "Total Importado",
          thClass: "text-right",
          tdClass: "text-right",
        },
        {
          key: "peso_dua",
          label: "% del Modelo",
          thClass: "text-right",
          tdClass: "text-right",
        },
      ],

      rawRows: [],
      tableRows: [],
      filtered: [],

      loading: false,
      q: "",
      batches: [],
      selectedBatchId: null,

      perPage: 10,
      currentPage: 1,
      perPageOptions: [10, 25, 50, 100],

      file: null,
      validFile: false,
      uploading: false,
    };
  },
  computed: {
    totalElements() {
      return this.filtered.length;
    },
    pagedRecords() {
      const start = (this.currentPage - 1) * this.perPage;
      return this.filtered.slice(start, start + this.perPage);
    },

    batchOptions() {
      return this.batches.map((b) => ({
        value: b.id,
        text: `#${b.id} · ${b.filename || "sin nombre"} · ${new Date(
          b.uploadedAt
        ).toLocaleString()} · ${b._count?.items || 0} items`,
      }));
    },
  },
  mounted() {
    this.fetchAndBuild();
    this.fetchBatches();
  },
  methods: {
    fmtPct(x) {
      return (x * 100).toFixed(2) + "%";
    },

    async fetchAndBuild() {
      try {
        this.loading = true;
        const resp = await ImportExcelService.listItems(
          `?offset=0&limit=50000`,
          this.$store
        );
        const rows = resp && resp.data && resp.data.rows ? resp.data.rows : [];
        this.rawRows = rows;

        this.tableRows = this.buildTable(rows);

        this.applyFilter();
        this.currentPage = 1;
      } catch (e) {
        this.$toast && this.$toast.error(e?.message || "Error al cargar");
      } finally {
        this.loading = false;
      }
    },

    async exportImportacion() {
      try {
        const rows = this.tableRows.map((r) => ({
          modelo: r.modelo,
          dua: r.dua,
          importador: r.importador || null,
          cantidad_dua: Number(r.cantidad_dua || 0),
          total_importado: Number(r.total_importado || 0),
          porcentaje_modelo: Number(r.peso_dua || 0),
        }));

        const headerKeys = [
          "modelo",
          "dua",
          "importador",
          "cantidad_dua",
          "total_importado",
          "porcentaje_modelo",
        ];
        const headerLabels = [
          [
            "Modelo",
            "DUA",
            "Importador",
            "Cant. DUA",
            "Total Importado",
            "% del Modelo",
          ],
        ];

        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(rows, {
          header: headerKeys,
          skipHeader: true,
        });
        XLSX.utils.sheet_add_aoa(ws, headerLabels, { origin: "A1" });

        const range = XLSX.utils.decode_range(ws["!ref"] || "A1");
        for (let R = 1; R <= range.e.r; R++) {
          const cellAddr = XLSX.utils.encode_cell({ r: R, c: 5 });
          const cell = ws[cellAddr];
          if (cell) cell.z = "0.00%";
        }

        ws["!cols"] = [
          { wch: 16 }, // Modelo
          { wch: 18 }, // DUA
          { wch: 130 }, // Importador
          { wch: 12 }, // Cant. DUA
          { wch: 14 }, // Total Importado
          { wch: 14 }, // % del Modelo
        ];

        XLSX.utils.book_append_sheet(wb, ws, "Importación");
        XLSX.writeFile(wb, "importacion.xlsx");
      } catch (e) {
        console.error(e);
        this.$toast && this.$toast.error("No se pudo exportar la importación");
      }
    },

    buildTable(rows) {
      const tot = new Map();
      rows.forEach((r) => {
        tot.set(r.modelo, (tot.get(r.modelo) || 0) + (r.cantidad || 0));
      });

      const acc = new Map();
      rows.forEach((r) => {
        const k = `${r.modelo}|||${r.dua}`;
        if (!acc.has(k))
          acc.set(k, {
            modelo: r.modelo,
            dua: r.dua,
            importador: r.importador,
            cantidad_dua: 0,
          });
        acc.get(k).cantidad_dua += r.cantidad || 0;
      });

      const out = [];
      acc.forEach((v) => {
        const total = tot.get(v.modelo) || 0;
        out.push({
          modelo: v.modelo,
          dua: v.dua,
          importador: v.importador,
          cantidad_dua: v.cantidad_dua,
          total_importado: total,
          peso_dua: total > 0 ? v.cantidad_dua / total : 0,
        });
      });

      out.sort(
        (a, b) => a.modelo.localeCompare(b.modelo) || a.dua.localeCompare(b.dua)
      );
      return out;
    },

    async fetchBatches() {
      const resp = await ImportExcelService.listBatches(this.$store);
      this.batches = !resp?.error && Array.isArray(resp.data) ? resp.data : [];

      const batchIds = Array.from(
        new Set((this.rawRows || []).map((r) => r.batchId).filter(Boolean))
      );
      if (batchIds.length === 1) this.selectedBatchId = batchIds[0];
      if (!this.selectedBatchId && this.batches.length)
        this.selectedBatchId = this.batches[0].id;
    },

    async onSoftDelete() {
      if (!this.selectedBatchId) {
        this.$toast && this.$toast.info("Selecciona un batch primero");
        return;
      }
      if (
        !confirm(
          `¿Eliminar lógicamente el batch #${this.selectedBatchId} y todos sus items?`
        )
      )
        return;

      this.loading = true;
      try {
        const resp = await ImportExcelService.softDeleteBatch(
          this.selectedBatchId,
          this.$store
        );
        if (!resp?.error) {
          this.$toast && this.$toast.success("Batch eliminado");
          await Promise.all([this.fetchBatches(), this.fetchAndBuild()]);
          if (this.batches.every((b) => b.id !== this.selectedBatchId))
            this.selectedBatchId = null;
        } else {
          this.$toast &&
            this.$toast.error(resp.message || "No se pudo eliminar");
        }
      } catch (e) {
        this.$toast && this.$toast.error(e?.message || "Error al eliminar");
      } finally {
        this.loading = false;
      }
    },

    applyFilter() {
      const q = (this.q || "").toString().trim().toLowerCase();
      if (!q) {
        this.filtered = this.tableRows.slice();
      } else {
        this.filtered = this.tableRows.filter(
          (r) =>
            (r.modelo && r.modelo.toLowerCase().includes(q)) ||
            (r.dua && r.dua.toLowerCase().includes(q))
        );
      }
      this.currentPage = 1;
    },

    rebuildPagination() {
      this.currentPage = 1;
    },

    openUploader() {
      this.file = null;
      this.validFile = false;
      this.uploading = false;
      this.$bvModal.show("upload-modal");
    },
    validateFile(file) {
      this.validFile = !!file && /\.xlsx$/i.test(file.name);
    },
    async submitUpload() {
      try {
        this.uploading = true;
        await ImportExcelService.uploadExcel(this.file, this.$store);
        this.$bvModal.hide("upload-modal");
        await this.fetchAndBuild();
        this.$toast && this.$toast.success("Archivo importado correctamente");
      } catch (e) {
        this.$toast && this.$toast.error(e?.message || "Error al importar");
      } finally {
        this.uploading = false;
      }
    },
  },
};
</script>
